var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$can(_vm.ActionEnum.READ, _vm.ResourceEnum.PARTNER, _vm.partnerId))?_c('div',[_c('the-navigation-layout',{attrs:{"items":_vm.items,"title":_vm.title,"isEnabled":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }